import { ProgressValues } from '@pc/progress-step-indicator';
import { NewUserTripStep, TripStep } from './trip-step.enum';

export const stepProgressMap = {
  [TripStep.WhoStep]: ProgressValues.Ten,
  [TripStep.WhereStep]: ProgressValues.Forty,
  [TripStep.WhenStep]: ProgressValues.Seventy
};

export const newUserStepProgressMap = {
  [NewUserTripStep.WhereStep]: ProgressValues.Ten,
  [NewUserTripStep.WhenStep]: ProgressValues.Forty,
  [NewUserTripStep.WhoStep]: ProgressValues.Seventy
};

export const fragmentsProgressMap = {
  [TripStep.WhoStep]: 'who',
  [TripStep.WhereStep]: 'where',
  [TripStep.WhenStep]: 'when'
};

export const newUserFragmentsProgressMap = {
  [NewUserTripStep.WhereStep]: 'where',
  [NewUserTripStep.WhenStep]: 'when',
  [NewUserTripStep.WhoStep]: 'who'
};
